import { FC } from 'react';

import { VSpacing } from '@hh.ru/magritte-ui';

import SectionTabs from 'components/Admin/SectionTabs/SectionTabs';

const Nav: FC = () => {
    return (
        <>
            <SectionTabs />
            <VSpacing default={24} />
        </>
    );
};

export default Nav;
